/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import video from '../assets/images/model/video_icon.svg';
import linkColunm from '../assets/images/model/linkColumn.svg';
import audioIcon from '../assets/images/model/audio-icon.svg';
import plusCircle from '../assets/images/model/plus-addmedia.svg';
import imageIcon from '../assets/images/model/image-icon.svg';
import './questionstypes.css';
import dots from '../assets/images/greay_drag.svg';
import dragWhite from '../assets/images/drag_white.svg';
import angleDown from '../assets/images/angle_up_down.svg';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import ImageUploadQ from '../Pages/Book/questionTypeMedia/ImageUploadQ';
import AudioUploadQ from '../Pages/Book/questionTypeMedia/AudioUploadQ';
import VideoUploadQ from '../Pages/Book/questionTypeMedia/VideoUploadQ';

const MatchingColumnOption = ({ isEditing, questionMatching, setQuestionMatching }) => {
  const [textareaHeights, setTextareaHeights] = useState(() => questionMatching.map((question) => question.leftOptions.map(() => 40)));
  const [uploadSide, setUploadSide] = useState(null);
  const [uploadQuestionIndex, setUploadQuestionIndex] = useState(null);
  const [uploadOptionIndex, setUploadOptionIndex] = useState(null);
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [showAudioUploadModal, setShowAudioUploadModal] = useState(false);
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);

  const isS3Url = (url) => {
    return url.includes('s3.amazonaws.com');
  };

  const isYouTubeUrl = (url) => {
    return url.includes('youtube.com') || url.includes('youtu.be');
  };

  const getDragHandleHeight = (optionType, currentHeight) => {
    const defaultHeights = {
      text: 32,
      image: 115,
      video: 115,
      audio: 115,
    };
    const defaultHeight = defaultHeights[optionType] || 40;

    return defaultHeight + Math.max(currentHeight - 40, 0);
  };

  const handleInputChange = (e, questionIndex, side, index) => {
    const { value } = e.target;
    const newOptions = [...questionMatching[questionIndex][`${side}Options`]];
    newOptions[index].text = value;
    updateQuestionOptions(questionIndex, side, newOptions);

    // Update textarea heights
    setTextareaHeights((prevHeights) => {
      const newHeights = [...prevHeights];
      newHeights[questionIndex][index] = e.target.scrollHeight; // Update height based on textarea's scrollHeight

      // Adjust height to minimum if empty
      if (value === '') {
        newHeights[questionIndex][index] = 40; // Set to default height when empty
      }

      return newHeights;
    });
  };

  const updateQuestionOptions = (questionIndex, side, newOptions) => {
    const newQuestionMatching = [...questionMatching];
    newQuestionMatching[questionIndex][`${side}Options`] = newOptions;
    setQuestionMatching(newQuestionMatching);
  };
  const handleDragStart = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    window.addEventListener('dragstart', handleDragStart);
    window.addEventListener('drop', handleDragStart);

    return () => {
      window.removeEventListener('dragstart', handleDragStart);
      window.removeEventListener('drop', handleDragStart);
    };
  }, []);

  const onDragEnd = (result, questionIndex) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const items = Array.from(questionMatching[questionIndex].rightOptions);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);
    updateQuestionOptions(questionIndex, 'right', items);
  };

  const handleImageOptionClick = (side, questionIndex, optionIndex) => {
    setUploadSide(side);
    setUploadQuestionIndex(questionIndex);
    setUploadOptionIndex(optionIndex);
    setShowImageUploadModal(true);
  };

  const handleAudioOptionClick = (side, questionIndex, optionIndex) => {
    setUploadSide(side);
    setUploadQuestionIndex(questionIndex);
    setUploadOptionIndex(optionIndex);
    setShowAudioUploadModal(true);
  };

  const handleVideoOptionClick = (side, questionIndex, optionIndex) => {
    setUploadSide(side);
    setUploadQuestionIndex(questionIndex);
    setUploadOptionIndex(optionIndex);
    setShowVideoUploadModal(true); // Show video modal
  };

  const handleImageUploaded = (imageFile) => {
    if (uploadSide && uploadQuestionIndex !== null && uploadOptionIndex !== null) {
      const newOptions = [...questionMatching[uploadQuestionIndex][`${uploadSide}Options`]];
      newOptions[uploadOptionIndex].imageFile = imageFile;
      updateQuestionOptions(uploadQuestionIndex, uploadSide, newOptions);
    }
    setUploadSide(null);
    setUploadQuestionIndex(null);
    setUploadOptionIndex(null);
  };

  const handleVideoUploaded = (videoFile) => {
    if (uploadSide && uploadQuestionIndex !== null && uploadOptionIndex !== null) {
      const newOptions = [...questionMatching[uploadQuestionIndex][`${uploadSide}Options`]];
      newOptions[uploadOptionIndex].videoFile = videoFile;
      updateQuestionOptions(uploadQuestionIndex, uploadSide, newOptions);
    }
    setUploadSide(null);
    setUploadQuestionIndex(null);
    setUploadOptionIndex(null);
  };

  const handleAudioUploaded = (audioFile) => {
    if (uploadSide && uploadQuestionIndex !== null && uploadOptionIndex !== null) {
      const newOptions = [...questionMatching[uploadQuestionIndex][`${uploadSide}Options`]];
      newOptions[uploadOptionIndex].audioFile = audioFile;
      updateQuestionOptions(uploadQuestionIndex, uploadSide, newOptions);
    }
    setUploadSide(null);
    setUploadQuestionIndex(null);
    setUploadOptionIndex(null);
  };
  return (
    <>
      {questionMatching.map((questionss, questionIndex) => (
        <div key={questionIndex} className='save_state_mcqs_not'>
          {questionss.type === 'matching' && (
            <>
              {isEditing ? (
                <div className='orderlist-item border_none short_option' style={{ background: '#fff' }}>
                  <div className='parent_input_with_image  edit_img_width'>
                    <div className='parent_input' style={{ display: 'block' }}>
                      {questionss.leftOptions.map((option, optionIndex) => (
                        <div key={option.id} className='option_matching mcqs_border' style={{ display: 'flex' }}>
                          <div style={{ position: 'relative', width: '100%' }}>
                            <div className='parent_link_col'>
                              <textarea
                                id={`textarea-left-${questionIndex}-${optionIndex}`}
                                className='orderlist-input text_input_padd'
                                placeholder={option.type === 'text' ? `Add text` : `Add text `}
                                rows={1}
                                value={option.text}
                                onChange={(e) => handleInputChange(e, questionIndex, 'left', optionIndex)}
                                style={{
                                  width: '100%',
                                  height: `${textareaHeights[questionIndex][optionIndex]}px`,
                                }}
                                disabled={!isEditing}
                              />

                              <div className='dropdown-arrow'>
                                <img src={angleDown} alt='down arrow' />
                              </div>
                            </div>

                            {(option.type === 'image' || option.type === 'video') && (
                              <div className='image_parent pr_4'>
                                {option.imageFile ? (
                                  <div className='input_image matching_col_height'>
                                    <img className='upload_image_order matching_col_height' src={option.imageFile} alt='' />
                                  </div>
                                ) : option.videoFile ? (
                                  <div className='input_image video_order_list matching_col_height'>
                                    {isS3Url(option.videoFile) ? (
                                      <video controls className='video_order_list matching_col_height'>
                                        <source src={option.videoFile} type='video/mp4' />
                                        Your browser does not support the video tag.
                                      </video>
                                    ) : isYouTubeUrl(option.videoFile) ? (
                                      <iframe className='video_order_list matching_col_height' style={{ borderRadius: '4px' }} src={option.videoFile} title='YouTube video player' frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' referrerPolicy='strict-origin-when-cross-origin' allowFullScreen></iframe>
                                    ) : (
                                      <div className='input_image matching_col_height' style={{ height: '77px' }} onClick={() => handleVideoOptionClick('left', questionIndex, optionIndex)}>
                                        <img src={video} alt='video' style={{ display: 'block' }} />
                                        <img src={plusCircle} className='plus_icon' alt='plus' />
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div
                                    className='input_image matching_col_height'
                                    onClick={() => {
                                      if (option.type === 'image') {
                                        handleImageOptionClick('left', questionIndex, optionIndex);
                                      } else if (option.type === 'video') {
                                        handleVideoOptionClick('left', questionIndex, optionIndex);
                                      }
                                    }}
                                  >
                                    <img src={option.type === 'image' ? imageIcon : video} alt='image' style={{ display: 'block' }} />
                                    <img src={plusCircle} className='plus_icon' alt='plus' />
                                  </div>
                                )}
                              </div>
                            )}
                            {option.type === 'audio' && (
                              <div className='image_parent pr_4'>
                                {option.audioFile ? (
                                  <div className='audio_boarder_order background_matching_col '>
                                    <div className={`deflat_content audio_file_parent_order ${option.text ? 'padding_none' : ''}`}>
                                      <span className='audio_file'>Audio file</span>
                                      <span className='view_transcript'>View transcript</span>
                                    </div>
                                    <AudioPlayer
                                      autoPlay={false}
                                      style={{ width: '100%' }}
                                      src={URL.createObjectURL(option.audioFile)}
                                      customAdditionalControls={[]}
                                      customVolumeControls={[]}
                                      showJumpControls={false}
                                      customProgressBarSection={[
                                        RHAP_UI.CURRENT_TIME,
                                        <div className='slash_time' key='slash'>
                                          /
                                        </div>,
                                        RHAP_UI.DURATION,
                                        RHAP_UI.PROGRESS_BAR,
                                      ]}
                                    />
                                  </div>
                                ) : (
                                  <div className='input_image input_audio ' onClick={() => handleAudioOptionClick('left', questionIndex, optionIndex)}>
                                    <img src={audioIcon} alt='audio' style={{ display: 'block' }} />
                                    <img src={plusCircle} className='plus_icon' alt='plus' />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                          <div className='link_col'>
                            <img src={linkColunm} alt='' style={{ width: '100%' }} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className='parent_input_with_image  save_img_width'>
                    <DragDropContext onDragEnd={(result) => onDragEnd(result, questionIndex)}>
                      <Droppable droppableId={`right-${questionIndex}`}>
                        {(provided) => (
                          <div ref={provided.innerRef} {...provided.droppableProps} className='parent_input' style={{ display: 'block' }}>
                            {questionss.rightOptions.map((option, optionIndex) => (
                              <Draggable key={option.id} draggableId={option.id} index={optionIndex}>
                                {(provided, snapshot) => (
                                  <div ref={provided.innerRef} {...provided.draggableProps} className={`option_matching mcqs_border ${snapshot.isDragging ? 'dragging_matching' : ''}`}>
                                    <div
                                      style={{
                                        display: 'flex',
                                      }}
                                    >
                                      <div
                                        {...provided.dragHandleProps}
                                        className={`drag-handle_order ${snapshot.isDragging ? 'border_right' : ''}`}
                                        style={{
                                          height: `${textareaHeights[questionIndex][optionIndex]}px`,
                                          minHeight: `${option.type === 'image' || option.type === 'video' ? '133px' : option.type === 'audio' ? '123px' : '40px'}`,
                                        }}
                                      >
                                        <img src={snapshot.isDragging ? dragWhite : dots} className='image_drag' alt='dots' />
                                      </div>
                                      <div className='long_option'>
                                        <div style={{ display: 'flex' }}>
                                          <textarea
                                            id={`textarea-right-${questionIndex}-${optionIndex}`}
                                            className='orderlist-input text_input_padd'
                                            placeholder={option.type === 'text' ? `Add text` : `Add text `}
                                            rows={1}
                                            value={option.text}
                                            onChange={(e) => handleInputChange(e, questionIndex, 'right', optionIndex)}
                                            style={{
                                              width: '100%',
                                              color: snapshot.isDragging ? '#6700b2' : '',
                                              height: `${textareaHeights[questionIndex][optionIndex]}px`,
                                            }}
                                            disabled={!isEditing}
                                          />
                                          <div className='dropdown-arrow'>
                                            <img src={angleDown} alt='down arrow' />
                                          </div>
                                        </div>
                                        <div>
                                          {(option.type === 'image' || option.type === 'video') && (
                                            <div className='image_parent '>
                                              {option.imageFile ? (
                                                <div className='input_image matching_col_height'>
                                                  <img className='upload_image_order  matching_col_height' src={option.imageFile} alt='' />
                                                </div>
                                              ) : option.videoFile ? (
                                                <div className='input_image video_order_list matching_col_height'>
                                                  {isS3Url(option.videoFile) ? (
                                                    <video controls className='video_order_list matching_col_height'>
                                                      <source src={option.videoFile} type='video/mp4' />
                                                      Your browser does not support the video tag.
                                                    </video>
                                                  ) : isYouTubeUrl(option.videoFile) ? (
                                                    <iframe
                                                      className='video_order_list matching_col_height'
                                                      style={{
                                                        borderRadius: '4px',
                                                      }}
                                                      src={option.videoFile}
                                                      title='YouTube video player'
                                                      frameBorder='0'
                                                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                                      referrerPolicy='strict-origin-when-cross-origin'
                                                      allowFullScreen
                                                    ></iframe>
                                                  ) : (
                                                    <div className='input_image matching_col_height' onClick={() => handleVideoOptionClick('right', questionIndex, optionIndex)}>
                                                      <img
                                                        src={video}
                                                        alt='video'
                                                        style={{
                                                          display: 'block',
                                                        }}
                                                      />
                                                      <img src={plusCircle} className='plus_icon' alt='plus' />
                                                    </div>
                                                  )}
                                                </div>
                                              ) : (
                                                <div
                                                  className='input_image matching_col_height'
                                                  onClick={() => {
                                                    if (option.type === 'image') {
                                                      handleImageOptionClick('right', questionIndex, optionIndex);
                                                    } else if (option.type === 'video') {
                                                      handleVideoOptionClick('right', questionIndex, optionIndex);
                                                    }
                                                  }}
                                                >
                                                  <img
                                                    src={option.type === 'image' ? imageIcon : video}
                                                    alt='image'
                                                    style={{
                                                      display: 'block',
                                                    }}
                                                  />
                                                  <img src={plusCircle} className='plus_icon' alt='plus' />
                                                </div>
                                              )}
                                            </div>
                                          )}
                                          {option.type === 'audio' && (
                                            <div className='image_parent'>
                                              {option.audioFile ? (
                                                <div className='audio_boarder_order background_matching_col '>
                                                  <div className={`deflat_content audio_file_parent_order ${option.text ? 'padding_none' : ''}`}>
                                                    <span className='audio_file'>Audio file</span>
                                                    <span className='view_transcript'>View transcript</span>
                                                  </div>
                                                  <AudioPlayer
                                                    autoPlay={false}
                                                    style={{ width: '100%' }}
                                                    src={URL.createObjectURL(option.audioFile)}
                                                    customAdditionalControls={[]}
                                                    customVolumeControls={[]}
                                                    showJumpControls={false}
                                                    customProgressBarSection={[
                                                      RHAP_UI.CURRENT_TIME,
                                                      <div className='slash_time' key='slash'>
                                                        /
                                                      </div>,
                                                      RHAP_UI.DURATION,
                                                      RHAP_UI.PROGRESS_BAR,
                                                    ]}
                                                  />
                                                </div>
                                              ) : (
                                                <div
                                                  className='input_image input_audio '
                                                  onClick={() => {
                                                    handleAudioOptionClick('right', questionIndex, optionIndex);
                                                  }}
                                                >
                                                  <img
                                                    src={audioIcon}
                                                    alt='audio'
                                                    style={{
                                                      display: 'block',
                                                    }}
                                                  />
                                                  <img src={plusCircle} className='plus_icon' alt='plus' />
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                </div>
              ) : (
                <div className={`orderlist-item border_none short_option `} style={{ background: '#fff' }}>
                  <div className='parent_input_with_image edit_img_width'>
                    <div className='parent_input' style={{ display: 'block' }}>
                      {questionss.leftOptions.map((option, optionIndex) => (
                        <div key={option.id} className={`option_matching mcqs_border ${!isEditing ? 'save_state_border' : ''}`} style={{ display: 'flex' }}>
                          <div style={{ position: 'relative', width: '100%' }}>
                            <div className='parent_link_col' style={{ display: 'block' }}>
                              <div
                                className='orderlist-input option_save_state'
                                style={{
                                  minHeight: '32px',
                                  height: 'auto',
                                  whiteSpace: 'break-spaces',
                                  wordBreak: 'break-word',
                                  padding: '8px',
                                }}
                              >
                                {option.text}
                              </div>

                              <div>
                                {(option.type === 'image' || option.type === 'video') && (
                                  <div className='image_parent pr_4'>
                                    {option.imageFile ? (
                                      <div className='input_image matching_col_height'>
                                        <img className='upload_image_order  matching_col_height' src={option.imageFile} alt='' />
                                      </div>
                                    ) : option.videoFile ? (
                                      <div className='input_image video_order_list matching_col_height'>
                                        {/* Render video based on URL type */}
                                        {isS3Url(option.videoFile) ? (
                                          <video controls className='video_order_list matching_col_height'>
                                            <source src={option.videoFile} type='video/mp4' />
                                            Your browser does not support the video tag.
                                          </video>
                                        ) : isYouTubeUrl(option.videoFile) ? (
                                          <iframe className='video_order_list matching_col_height' style={{ borderRadius: '4px' }} src={option.videoFile} title='YouTube video player' frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' referrerPolicy='strict-origin-when-cross-origin' allowFullScreen></iframe>
                                        ) : (
                                          // Placeholder for handling video upload click
                                          <div className='input_image matching_col_height'>
                                            <img src={video} alt='video' style={{ display: 'block' }} />
                                            <img src={plusCircle} className='plus_icon' alt='plus' />
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      // Placeholder for handling image upload click
                                      <div className='input_image matching_col_height'>
                                        <img src={option.type === 'image' ? imageIcon : video} alt='image' style={{ display: 'block' }} />
                                        <img src={plusCircle} className='plus_icon' alt='plus' />
                                      </div>
                                    )}
                                  </div>
                                )}
                                {option.type === 'audio' && (
                                  <div className='image_parent pr_4'>
                                    {option.audioFile ? (
                                      <div className='audio_boarder_order background_matching_col '>
                                        <div className={`deflat_content audio_file_parent_order ${option.text ? 'padding_none' : ''}`}>
                                          <span className='audio_file'>Audio file</span>
                                          <span className='view_transcript'>View transcript</span>
                                        </div>
                                        {/* Render audio player for uploaded audio file */}
                                        <AudioPlayer
                                          autoPlay={false}
                                          style={{ width: '100%' }}
                                          src={URL.createObjectURL(option.audioFile)}
                                          customAdditionalControls={[]}
                                          customVolumeControls={[]}
                                          showJumpControls={false}
                                          customProgressBarSection={[
                                            RHAP_UI.CURRENT_TIME,
                                            <div className='slash_time' key='slash'>
                                              /
                                            </div>,
                                            RHAP_UI.DURATION,
                                            RHAP_UI.PROGRESS_BAR,
                                          ]}
                                        />
                                      </div>
                                    ) : (
                                      // Placeholder for handling audio upload click
                                      <div className='input_image input_audio '>
                                        <img src={audioIcon} alt='audio' style={{ display: 'block' }} />
                                        <img src={plusCircle} className='plus_icon' alt='plus' />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className='link_col'>
                            <img src={linkColunm} alt='' style={{ width: '100%' }} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className='parent_input_with_image save_img_width'>
                    <DragDropContext onDragEnd={(result) => onDragEnd(result, questionIndex)}>
                      <Droppable droppableId={`right-${questionIndex}`}>
                        {(provided) => (
                          <div ref={provided.innerRef} {...provided.droppableProps} className='parent_input' style={{ display: 'block' }}>
                            {questionss.rightOptions.map((option, optionIndex) => (
                              <Draggable key={option.id} draggableId={option.id} index={optionIndex}>
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    className={`option_matching mcqs_border ${!isEditing ? 'save_state_border' : ''} `}
                                    style={{
                                      height: '100%',
                                      minHeight: `${'32px'}`,
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        height: '100%',
                                      }}
                                    >
                                      <div
                                        className={`drag-handle_order opacity_5  `}
                                        style={{
                                          minHeight: `${option.type === 'image' || option.type === 'video' ? '133px' : option.type === 'audio' ? '115px' : '32px'}`,
                                        }}
                                      >
                                        <img src={dots} className='image_drag' alt='dots' />
                                      </div>
                                      <div className='long_option'>
                                        <div
                                          className='orderlist-input option_save_state'
                                          style={{
                                            whiteSpace: 'break-spaces',
                                            minHeight: '32px',
                                            wordBreak: 'break-word',
                                            height: 'auto',
                                            paddingLeft: '8px',
                                          }}
                                        >
                                          {option.text}
                                        </div>

                                        <div>
                                          {(option.type === 'image' || option.type === 'video') && (
                                            <div className='image_parent '>
                                              {option.imageFile ? (
                                                <div className='input_image matching_col_height'>
                                                  <img className='upload_image_order  matching_col_height' src={option.imageFile} alt='' />
                                                </div>
                                              ) : option.videoFile ? (
                                                <div className='input_image video_order_list matching_col_height'>
                                                  {/* Render video based on URL type */}

                                                  {isS3Url(option.videoFile) ? (
                                                    <video controls className='video_order_list matching_col_height'>
                                                      <source src={option.videoFile} type='video/mp4' />
                                                      Your browser does not support the video tag.
                                                    </video>
                                                  ) : isYouTubeUrl(option.videoFile) ? (
                                                    <iframe
                                                      className='video_order_list matching_col_height'
                                                      style={{
                                                        borderRadius: '4px',
                                                      }}
                                                      src={option.videoFile}
                                                      title='YouTube video player'
                                                      frameBorder='0'
                                                      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                                      referrerPolicy='strict-origin-when-cross-origin'
                                                      allowFullScreen
                                                    ></iframe>
                                                  ) : (
                                                    // Placeholder for handling video upload click
                                                    <div className='input_image matching_col_height'>
                                                      <img
                                                        src={video}
                                                        alt='video'
                                                        style={{
                                                          display: 'block',
                                                        }}
                                                      />
                                                      <img src={plusCircle} className='plus_icon' alt='plus' />
                                                    </div>
                                                  )}
                                                </div>
                                              ) : (
                                                // Placeholder for handling image upload click
                                                <div className='input_image matching_col_height'>
                                                  <img
                                                    src={option.type === 'image' ? imageIcon : video}
                                                    alt='image'
                                                    style={{
                                                      display: 'block',
                                                    }}
                                                  />
                                                  <img src={plusCircle} className='plus_icon' alt='plus' />
                                                </div>
                                              )}
                                            </div>
                                          )}
                                          {option.type === 'audio' && (
                                            <div className='image_parent'>
                                              {option.audioFile ? (
                                                <div className='audio_boarder_order background_matching_col '>
                                                  <div className={`deflat_content audio_file_parent_order ${option.text ? 'padding_none' : ''}`}>
                                                    <span className='audio_file'>Audio file</span>
                                                    <span className='view_transcript'>View transcript</span>
                                                  </div>
                                                  {/* Render audio player for uploaded audio file */}
                                                  <AudioPlayer
                                                    autoPlay={false}
                                                    style={{ width: '100%' }}
                                                    src={URL.createObjectURL(option.audioFile)}
                                                    customAdditionalControls={[]}
                                                    customVolumeControls={[]}
                                                    showJumpControls={false}
                                                    customProgressBarSection={[
                                                      RHAP_UI.CURRENT_TIME,
                                                      <div className='slash_time' key='slash'>
                                                        /
                                                      </div>,
                                                      RHAP_UI.DURATION,
                                                      RHAP_UI.PROGRESS_BAR,
                                                    ]}
                                                  />
                                                </div>
                                              ) : (
                                                // Placeholder for handling audio upload click
                                                <div className='input_image input_audio '>
                                                  <img
                                                    src={audioIcon}
                                                    alt='audio'
                                                    style={{
                                                      display: 'block',
                                                    }}
                                                  />
                                                  <img src={plusCircle} className='plus_icon' alt='plus' />
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      ))}
      {showImageUploadModal && <ImageUploadQ onImageUploadedQ={handleImageUploaded} setUploadImageShow={setShowImageUploadModal} />}
      {showAudioUploadModal && <AudioUploadQ onAudioUploadedQ={handleAudioUploaded} setShowAudioUploadModal={setShowAudioUploadModal} />}
      {showVideoUploadModal && <VideoUploadQ onAudioUploadedQ={handleVideoUploaded} setShowVideoUploadModal={setShowVideoUploadModal} />}
    </>
  );
};

export default MatchingColumnOption;
